const DEFAULT_TTL_SECONDS = 60 * 60;
const DEFAULT_PAGE_HAS_EXPERIMENTS_TTL_SECONDS = 60 * 60;

function parseTtl(rawValue: string | undefined, fallback: number): number {
  const parsed = Number(rawValue);
  return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
}

export const REDIS_TTL_SECONDS = parseTtl(process.env.REDIS_TTL_SECONDS, DEFAULT_TTL_SECONDS);
export const PAGE_HAS_EXPERIMENTS_TTL_SECONDS = parseTtl(
  process.env.REDIS_PAGE_HAS_EXPERIMENTS_TTL_SECONDS,
  DEFAULT_PAGE_HAS_EXPERIMENTS_TTL_SECONDS,
);

export const RedisKey = {
  Page: 'page',
  PageHasExperiments: 'page_has_experiments',
  PageNinetailedData: 'page_nt_data',
  SiteSettings: 'site_settings',
  ItgConcepts: 'itg_concepts',
} as const;

export type RedisKeyType = (typeof RedisKey)[keyof typeof RedisKey];

export const TTL_BY_REDIS_KEY: Record<RedisKeyType, number> = {
  [RedisKey.Page]: REDIS_TTL_SECONDS,
  [RedisKey.PageHasExperiments]: PAGE_HAS_EXPERIMENTS_TTL_SECONDS,
  [RedisKey.PageNinetailedData]: PAGE_HAS_EXPERIMENTS_TTL_SECONDS,
  [RedisKey.SiteSettings]: REDIS_TTL_SECONDS,
  [RedisKey.ItgConcepts]: REDIS_TTL_SECONDS,
};
